import script from "./BackgroundPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackgroundPopup.vue?vue&type=script&setup=true&lang=ts"

import "./BackgroundPopup.vue?vue&type=style&index=0&id=002a3bfe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-002a3bfe"]])

export default __exports__